import { Banner, Button, QuestionAnswerIcon } from '@farol-ds/react'
import { useMetrics } from '@jusbrasil-web/docview/core'
import { useOnScreen } from '@jusbrasil-web/shared-hooks'
import { useEffect, useMemo, useRef } from 'react'

import {
  WHATSAPP_URL_WITH_TEXT,
  WHATSAPP_URL_WITH_TEXT_ARTIGOS,
  WHATSAPP_URL_WITH_TEXT_NOTICIAS,
} from '../../constants'
import { getUserAgentProperties } from '../../utils/user-agent'
import styles from './orientation-banner.module.scss'

export function OrientationBanner() {
  const { ref, sendMetrics, metricsProperties } = useMetrics<HTMLDivElement>()
  const CTA_TEXT = 'Solicitar orientação'
  const ctaRef = useRef<HTMLButtonElement>(null)
  const metricSent = useRef<boolean>(false)

  const isCtaOnScreen = useOnScreen(ctaRef, { threshold: 1 }, false)

  const userAgentProps = getUserAgentProperties()

  const metadata = useMemo(
    () => ({
      copy: CTA_TEXT,
      page: 'docview-artigo',
      action: 'open_chat',
      position: 'text',
      doc_id: metricsProperties.doc_id,
    }),
    [metricsProperties.doc_id]
  )

  useEffect(() => {
    if (isCtaOnScreen && !metricSent.current) {
      sendMetrics('SeusDireitos.CtaView', {
        app_id: 'web-docview',
        page: metadata.page,
        browser: userAgentProps.browser,
        os: userAgentProps.os,
        user_agent: userAgentProps.user_agent,
        dvce_type: userAgentProps.dvce_type,
        dvce_ismobile: userAgentProps.dvce_ismobile,
        device_name: userAgentProps.device_name,
        metadata,
      })

      metricSent.current = true
    }
  }, [isCtaOnScreen, sendMetrics, metadata, userAgentProps])

  const navigateToChat = () => {
    sendMetrics('SeusDireitos.CtaClick', {
      app_id: 'web-docview',
      page: metadata.page,
      browser: userAgentProps.browser,
      os: userAgentProps.os,
      user_agent: userAgentProps.user_agent,
      dvce_type: userAgentProps.dvce_type,
      dvce_ismobile: userAgentProps.dvce_ismobile,
      device_name: userAgentProps.device_name,
      metadata,
    })
    sendMetrics('SeusDireitos.QuestionSent', {
      app_id: 'web-docview',
      page: metadata.page,
      browser: userAgentProps.browser,
      os: userAgentProps.os,
      user_agent: userAgentProps.user_agent,
      dvce_type: userAgentProps.dvce_type,
      dvce_ismobile: userAgentProps.dvce_ismobile,
      device_name: userAgentProps.device_name,
      metadata,
    })

    let url = WHATSAPP_URL_WITH_TEXT
    if (metadata?.page === 'docview-artigo') {
      url = WHATSAPP_URL_WITH_TEXT_ARTIGOS
    } else if (metadata?.page === 'docview-noticia') {
      url = WHATSAPP_URL_WITH_TEXT_NOTICIAS
    }
    window.open(url, '_blank')
  }

  return (
    <Banner type="positive" className={styles.banner} ref={ref}>
      <Banner.Content>
        <Banner.Title asChild>
          <div className={styles.title}>
            <Banner.Icon>
              <QuestionAnswerIcon />
            </Banner.Icon>
            Está com dúvidas sobre seus direitos
          </div>
        </Banner.Title>
        <Banner.Description asChild>
          <span>Receba orientações iniciais e entenda o que fazer no seu caso.</span>
        </Banner.Description>
      </Banner.Content>
      <Banner.Action>
        <Button size={'md'} kind="tertiary" onClick={() => navigateToChat()} ref={ctaRef}>
          {CTA_TEXT}
        </Button>
      </Banner.Action>
    </Banner>
  )
}
